// extracted by mini-css-extract-plugin
export default {"loadMoreButtonWrapper":"PaginationWrapper_loadMoreButtonWrapper__9muaW"};